/* ============================================================================
   LAH — OFERTA DE ULTIMA CHANCE AO SEGUIR SO COM A ARMACAO
   Tema: Outubro (Pre Green Friday 2.0)

   ============================================================================
   LIGA E DESLIGA — Configuracoes do tema > Lahtref > Oferta ao seguir sem
   lentes. Desligada, o carregador nem inclui este arquivo; a checagem de
   window.LAH_OFERTA aqui e a segunda tranca, para o caso de o script ser
   incluido por outro caminho.

   Cupom, tempo do cronometro, titulo e texto vem todos de la.

   ============================================================================
   A OFERTA E UMA ETAPA DO QUESTIONARIO, NAO UMA TELA SOLTA
   ============================================================================
   Antes era um modal no corpo da pagina, e duas coisas davam errado:

     CAMADA ... o painel de lentes tem contexto de empilhamento proprio e
                ficava por cima — a oferta so aparecia depois de o cliente
                sair do fluxo.
     FLUXO .... era uma tela de outro lugar interrompendo uma conversa.

   Agora ela e injetada DENTRO do overlay do questionario, ao lado de
   "motivos", "receita" e "reserva": mesma caixa, mesma camada, sem sair de
   onde estava.

   A TROCA DE ETAPA SEGUE A REGRA DO OUTRO ARQUIVO: "motivos" por display, as
   demais por is-active. Assim nossa etapa desaparece sozinha se o
   lah-frameonly trocar de etapa, sem precisarmos avisa-lo.

   ============================================================================
   QUANDO APARECE — e quando nao
   ============================================================================
   So no botao data-lah-fo-continue: o "seguir so com a armacao", ja dentro do
   questionario.

   NAO no primeiro clique em "apenas armacao" — esse abre o questionario, e
   interromper ali atropelaria as perguntas sobre receita e consulta.
   NAO em "escolher lentes e comprar": quem disse sim nao precisa de desconto.

   Gatilho por ATRIBUTO, nao por texto: comparar frases fazia a oferta
   disparar no lugar errado.

   ============================================================================
   OS DOIS DESFECHOS
   ============================================================================
   GARANTIR ... copia o cupom e clica no proprio "escolher lentes" do
                questionario — o lah-frameonly registra a recuperacao e fecha
                do jeito que ele espera.
   NAO QUERO .. repete o clique original com uma marca que este script ignora;
                sem ela, o clique voltaria para ca em laco.

   O CRONOMETRO pressiona, mas nao pune: zerando, cupom e botao continuam
   funcionando. UMA VEZ POR VISITA. O limite real do cupom vive no admin.
   ============================================================================ */

(function () {
    'use strict';

    var CFG = window.LAH_OFERTA || {};
    if (CFG.ativa === false) return;

    var CUPOM = CFG.cupom || 'ESPECIAL30';
    var SEGUNDOS = parseInt(CFG.segundos, 10) || 30;
    var TITULO = CFG.titulo || 'Suas lentes podem custar 30% menos';
    var TEXTO = CFG.texto || 'Você não precisa da receita agora. Garanta o cupom, escolha as lentes e envie a receita depois pelo WhatsApp.';

    var CHAVE = 'lah_sem_lentes_visto';
    var GATILHO = '[data-lah-fo-continue]';
    var VOLTAR = '[data-lah-fo-choose-lens]';
    var ETAPA = 'lah-oferta';

    var overlay = document.getElementById('lah-frameonly');
    if (!overlay) return;

    var etapa = null;
    var relogio = null;
    var origem = null;

    function track(ev, dados) {
        try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(Object.assign({ event: ev }, dados || {}));
        } catch (e) {}
    }

    function jaViu() {
        try { return sessionStorage.getItem(CHAVE) === '1'; } catch (e) { return false; }
    }

    function marcarVisto() {
        try { sessionStorage.setItem(CHAVE, '1'); } catch (e) {}
    }

    function copiar() {
        try {
            navigator.clipboard.writeText(CUPOM);
            return true;
        } catch (e) {
            return false;
        }
    }

    function esc(t) {
        return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    function doisDigitos(n) { return n < 10 ? '0' + n : String(n); }

    /* ---------------------------------------------------------------------
       ESTILO — dentro da caixa do questionario, nao sobre a pagina
       --------------------------------------------------------------------- */
    var estilo = document.createElement('style');
    estilo.textContent =
        '[data-lah-fo-step="' + ETAPA + '"]{display:none;text-align:center;}' +
        '[data-lah-fo-step="' + ETAPA + '"].is-active{display:block;}' +
        '.lah-sl__emoji{display:block;font-size:44px;line-height:1;margin:0 0 10px;}' +
        '.lah-sl__t{font-size:22px;font-weight:700;line-height:1.18;margin:0 0 8px;letter-spacing:-.01em;}' +
        '.lah-sl__p{font-size:15px;line-height:1.5;opacity:.75;margin:0 0 18px;}' +
        '.lah-sl__crono{margin:0 0 18px;}' +
        '.lah-sl__tempo{display:block;font-size:42px;font-weight:700;line-height:1;' +
        'font-variant-numeric:tabular-nums;color:#B4341F;letter-spacing:.02em;}' +
        '.lah-sl__leg{display:block;font-size:11px;letter-spacing:.14em;text-transform:uppercase;' +
        'color:#98A1A8;margin-top:6px;}' +
        '.lah-sl__trilho{display:block;height:5px;border-radius:999px;background:#EDEFEE;' +
        'overflow:hidden;margin-top:12px;}' +
        '.lah-sl__barra{display:block;height:100%;width:100%;background:#B4341F;' +
        'border-radius:999px;transition:width 1s linear;}' +
        '.lah-sl__crono.is-urgente .lah-sl__tempo{animation:lah-sl-pulsa 1s ease-in-out infinite;}' +
        '@keyframes lah-sl-pulsa{0%,100%{transform:scale(1);}50%{transform:scale(1.06);}}' +
        '.lah-sl__crono.is-fim .lah-sl__tempo{color:#98A1A8;animation:none;}' +
        '.lah-sl__crono.is-fim .lah-sl__barra{background:#CDD3D0;}' +
        '.lah-sl__cupom{display:flex;align-items:center;justify-content:space-between;gap:12px;' +
        'border:2px dashed #2F6B46;border-radius:14px;padding:14px 16px;margin-bottom:16px;}' +
        '.lah-sl__cod{font-size:22px;font-weight:700;letter-spacing:.06em;color:#152F22;}' +
        '.lah-sl__copiar{background:#152F22;color:#fff;border:0;border-radius:999px;' +
        'padding:11px 18px;font:inherit;font-size:14px;font-weight:600;cursor:pointer;white-space:nowrap;}' +
        '.lah-sl__cta{display:block;width:100%;background:#2F6B46;color:#fff;border:0;' +
        'border-radius:999px;padding:16px;font:inherit;font-size:16px;font-weight:600;cursor:pointer;}' +
        '.lah-sl__sair{display:block;width:100%;background:none;border:0;margin-top:14px;' +
        'font:inherit;font-size:12px;color:#98A1A8;text-decoration:underline;cursor:pointer;}' +
        '.lah-sl-aviso{position:fixed;left:50%;bottom:24px;transform:translateX(-50%) translateY(12px);' +
        'z-index:2147483000;background:#152F22;color:#fff;border-radius:12px;padding:13px 18px;' +
        'font-size:14px;line-height:1.4;max-width:min(92vw,420px);text-align:center;' +
        'box-shadow:0 12px 30px rgba(0,0,0,.3);opacity:0;transition:opacity .3s ease,transform .3s ease;}' +
        '.lah-sl-aviso.is-on{opacity:1;transform:translateX(-50%) translateY(0);}' +
        '@media (prefers-reduced-motion: reduce){' +
        '.lah-sl__crono.is-urgente .lah-sl__tempo{animation:none;}' +
        '.lah-sl__barra{transition:none;}}';
    document.head.appendChild(estilo);

    function aviso(texto) {
        var el = document.createElement('div');
        el.className = 'lah-sl-aviso';
        el.setAttribute('role', 'status');
        el.textContent = texto;
        document.body.appendChild(el);

        requestAnimationFrame(function () { el.classList.add('is-on'); });

        setTimeout(function () {
            el.classList.remove('is-on');
            setTimeout(function () { el.remove(); }, 400);
        }, 5000);
    }

    /* ---------------------------------------------------------------------
       A ETAPA
       --------------------------------------------------------------------- */
    function criarEtapa() {
        if (etapa) return etapa;

        var irmas = overlay.querySelectorAll('[data-lah-fo-step]');
        if (!irmas.length) return null;

        var ultima = irmas[irmas.length - 1];

        etapa = document.createElement('div');
        etapa.setAttribute('data-lah-fo-step', ETAPA);

        etapa.innerHTML =
            '<span class="lah-sl__emoji" aria-hidden="true">👀</span>' +
            '<p class="lah-sl__t">' + esc(TITULO) + '</p>' +
            '<p class="lah-sl__p">' + esc(TEXTO) + '</p>' +

            '<div class="lah-sl__crono" data-sl-crono>' +
            '<span class="lah-sl__tempo" data-sl-tempo>00:' + doisDigitos(SEGUNDOS) + '</span>' +
            '<span class="lah-sl__leg" data-sl-leg>para garantir</span>' +
            '<span class="lah-sl__trilho"><span class="lah-sl__barra" data-sl-barra></span></span>' +
            '</div>' +

            '<div class="lah-sl__cupom">' +
            '<span class="lah-sl__cod">' + esc(CUPOM) + '</span>' +
            '<button type="button" class="lah-sl__copiar" data-sl-copiar>Copiar</button>' +
            '</div>' +

            '<button type="button" class="lah-sl__cta" data-sl-garantir>Garantir condição especial</button>' +
            '<button type="button" class="lah-sl__sair" data-sl-sair>Não quero descontos</button>';

        ultima.parentNode.insertBefore(etapa, ultima.nextSibling);
        return etapa;
    }

    /* Mesma regra do lah-frameonly — ver a nota no topo. */
    function mostrarEtapa() {
        var irmas = overlay.querySelectorAll('[data-lah-fo-step]');

        Array.prototype.forEach.call(irmas, function (s) {
            if (s === etapa) return;

            if (s.getAttribute('data-lah-fo-step') === 'reasons') {
                s.style.display = 'none';
            } else {
                s.classList.remove('is-active');
            }
        });

        etapa.classList.add('is-active');
    }

    function pararRelogio() {
        if (relogio) { clearInterval(relogio); relogio = null; }
    }

    function esconderEtapa() {
        pararRelogio();
        if (etapa) etapa.classList.remove('is-active');
    }

    function abrir(botaoOriginal) {
        origem = botaoOriginal;

        if (!criarEtapa()) return;

        marcarVisto();
        mostrarEtapa();
        track('lens_sem_lentes_barreira', { cupom: CUPOM });

        var crono = etapa.querySelector('[data-sl-crono]');
        var tempo = etapa.querySelector('[data-sl-tempo]');
        var leg = etapa.querySelector('[data-sl-leg]');
        var barra = etapa.querySelector('[data-sl-barra]');
        var resta = SEGUNDOS;

        crono.className = 'lah-sl__crono';
        tempo.textContent = '00:' + doisDigitos(SEGUNDOS);
        leg.textContent = 'para garantir';
        barra.style.width = '100%';

        pararRelogio();

        relogio = setInterval(function () {
            resta--;

            tempo.textContent = '00:' + doisDigitos(Math.max(0, resta));
            barra.style.width = (resta / SEGUNDOS * 100) + '%';

            if (resta <= 10 && resta > 0) crono.classList.add('is-urgente');

            if (resta > 0) return;

            pararRelogio();
            crono.classList.remove('is-urgente');
            crono.classList.add('is-fim');
            leg.textContent = 'válido enquanto esta tela estiver aberta';

            track('lens_sem_lentes_tempo_fim', {});
        }, 1000);
    }

    /* ---------------------------------------------------------------------
       ACOES
       --------------------------------------------------------------------- */
    overlay.addEventListener('click', function (event) {
        if (event.target.closest('[data-sl-copiar]')) {
            var botao = event.target.closest('[data-sl-copiar]');
            botao.textContent = copiar() ? 'Copiado' : 'Selecione e copie';
            track('lens_sem_lentes_copiou', { cupom: CUPOM });
            return;
        }

        if (event.target.closest('[data-sl-garantir]')) {
            var copiou = copiar();
            track('lens_sem_lentes_garantiu', { copiou: copiou });

            esconderEtapa();

            var voltar = overlay.querySelector(VOLTAR);
            if (voltar) {
                voltar.click();
            } else {
                var x = overlay.querySelector('[data-lah-fo-close]');
                if (x) x.click();
            }

            aviso(copiou
                ? 'Cupom ' + CUPOM + ' copiado. Escolha suas lentes — a receita você envia depois.'
                : 'Escolha suas lentes — a receita você envia depois.');
            return;
        }

        if (event.target.closest('[data-sl-sair]')) {
            track('lens_sem_lentes_seguiu', {});
            esconderEtapa();

            if (origem) {
                origem.setAttribute('data-sl-liberado', '1');
                origem.click();
            }
            return;
        }
    });

    /* Fechar o questionario por fora (X, Esc, clique no fundo) precisa parar o
       relogio: sem isso ele segue correndo com a tela invisivel. */
    if (window.MutationObserver) {
        new MutationObserver(function () {
            if (!overlay.classList.contains('is-open')) esconderEtapa();
        }).observe(overlay, { attributes: true, attributeFilter: ['class'] });
    }

    /* ---------------------------------------------------------------------
       O GATILHO — fase de captura, antes do lah-frameonly
       --------------------------------------------------------------------- */
    document.addEventListener('click', function (event) {
        var botao = event.target.closest(GATILHO);
        if (!botao) return;

        if (botao.hasAttribute('data-sl-liberado')) {
            botao.removeAttribute('data-sl-liberado');
            return;
        }

        if (jaViu()) return;

        event.preventDefault();
        event.stopPropagation();

        abrir(botao);
    }, true);
})();
